import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
import FormatUtils from 'src/utils/format.utils';
export const BalanceSectionComponent = ({ value, unit, label, skipLabelTranslation, decimals = 3, user, }) => {
    const effectiveDecimals = unit === 'TIME' ? 4 : decimals;
    return (React.createElement("div", { className: "balance-section" },
        label && (React.createElement("div", { className: "label" }, skipLabelTranslation ? label : getMessage(label))),
        user && React.createElement("div", { className: "user" }, user),
        React.createElement("div", { className: "value" },
            FormatUtils.formatCurrencyValue(value, effectiveDecimals),
            " ",
            unit)));
};
